<div class="link-box-container">
    <div class="link-box-header">
        <span>{{ title }}</span>
    </div>
    <div class="link-box-body">
        <ng-container *ngFor="let link of links">
            <div class="link" [ngClass]="{'link-success': link.type === 'success', 'link-warning': link.type === 'warning', 'link-error': link.type === 'error'}">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                </svg>
                {{ link.text }}
                <div
                        *ngIf="link.label"
                        class="label "
                        [ngClass]="{'label-success': link.type === 'success',
                        'label-error': link.type === 'warning' || link.type === 'error' }"
                > {{ link.label }} </div>
            </div>
        </ng-container>
    </div>
</div>
